import { useEffect } from "react";
import { useSortBy } from "react-instantsearch";

import { algoliaSortByOptions } from "../models/algolia-sort-attributes";

export function useSortFinishedProjectsByEndDate() {
  const sortValue = algoliaSortByOptions.scheduledEndDate.value;

  const { refine } = useSortBy({
    items: [algoliaSortByOptions.scheduledEndDate],
  });

  useEffect(() => {
    refine(sortValue);
  }, [sortValue, refine]);
}
